import React, { FunctionComponent, useState, useEffect } from "react";
import styles from "./Embed.module.scss";
import EmbedProps from "./EmbedProps.interface";

import Anchor from "components/Anchor/Anchor";
import combineClasses from "helpers/combine-classes";
import getWrapperClasses from "blocks/helpers/getWrapperClasses";
import IconViewer from "components/IconViewer/IconViewer";
import useAnchorIdentifier from "hooks/useAnchorIdentifier";

const Embed: FunctionComponent<EmbedProps> = (props) => {
    const wrapperClasses = getWrapperClasses(props.settings);
    const identifier = useAnchorIdentifier(props.settings.anchorIdentifier);

    const [showSnippet, setShowSnippet] = useState(true);

    const embedSizeClass = props.settings.size ? styles[props.settings.size] : undefined;

    useEffect(() => {
        setTimeout(() => {
            setShowSnippet(true);
        }, 1000);
    }, []);

    const loadScript = async (src: string) => {
        const promise = new Promise<void>((resolve, reject) => {
            const scriptElement = document.createElement("script");

            scriptElement.type = "text/javascript";
            scriptElement.async = false;
            scriptElement.onload = () => {
                resolve();
            };

            document.body.appendChild(scriptElement);
            scriptElement.src = src;
        });

        return promise;
    };

    useEffect(() => {
        if (showSnippet === true) {
            if (props.content.embeds?.includes("HR-ON")) {
                loadScript("https://recruit.hr-on.com/frame-api/hr.js");
                loadScript("https://recruit.hr-on.com/frame-api/customers/worklivestay.js");
            }
        }
    }, [showSnippet]);

    return (
        <section className={combineClasses([styles.wrapper, embedSizeClass, ...wrapperClasses])} id={identifier}>
            <div className={styles.container}>
                {/* Embed */}
                {props.content.embeds?.includes("HR-ON") ? (
                    <div id="hr-on"></div>
                ) : null}

                {/* Frame */}
                {props.content.iframe && showSnippet === true ? (
                    <div dangerouslySetInnerHTML={{ __html: props.content.iframe }} />
                ) : null}

                {/* Buttons */}
                {props.content.buttons && props.content.buttons.length > 0 ? (
                    <div className={styles.buttons}>
                        {props.content.buttons.map((button, index) => {
                            return (
                                <Anchor key={index} to={button.content.link} className={styles.button}>
                                    <IconViewer name="download" className={styles.download_icon} aspectRatioX={1} aspectRatioY={1} />
                                    <span>{button.content.label}</span>
                                </Anchor>
                            );
                        })}
                    </div>
                ) : null}
            </div>
        </section>
    );
};

export default Embed;
